import React, { useState } from 'react';

const LS_KEY = 'ps_promo_bar_dismissed';

const PromoTopBar = ({ promotions = [] }) => {
    const [dismissed, setDismissed] = useState(() => {
        try {
            return localStorage.getItem(LS_KEY) === '1';
        } catch {
            return false;
        }
    });

    // Берём самую приоритетную (первую в списке, т.к. бэк сортирует)
    const promo = promotions[0];
    if (!promo || dismissed) return null;

    const handleDismiss = () => {
        setDismissed(true);
        try {
            localStorage.setItem(LS_KEY, '1');
        } catch { }
    };

    return (
        <div className="bg-[#6B7A6A] text-white text-sm">
            <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-3 relative">
                <span className="text-base">🎁</span>
                <span className="text-center">
                    <strong>{promo.short_text}</strong>
                    {promo.ends_at && (
                        <span className="hidden sm:inline opacity-80 ml-2">
                            · до {promo.ends_at.slice(0, 10)}
                        </span>
                    )}
                </span>
                <button
                    onClick={handleDismiss}
                    aria-label="Закрыть"
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition text-xl leading-none"
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default PromoTopBar;